<!-- Revised on 2024/11/26 by mnavarro -->
<template>
  <div v-if="total > 0" class="d-flex align-items-center justify-content-center text-secondary text-sm">
    {{ $t('key_pager_information_showing_records')}}
    {{ startRow }}
    {{ $t('key_pager_information_to')}}
    {{ endRow }}
    {{ $t('key_pager_information_of')}}
    {{ total }}
    {{ $t('key_pager_information_records')}}
  </div>
</template>

<script>

  export default {
    name: "PagerInformation",
    props: {
      total:{
        type: Number,
        default: 0
      },
      current: {
        type: Number,
        default: 0
      },
      rows:{
        type:Number,
        default: 0
      }
    },
    computed: {
      startRow() {
        return (this.current - 1) * this.rows + 1;
      },
      endRow() {
        const possibleEnd = this.current * this.rows;
        return possibleEnd > this.total ? this.total : possibleEnd;
      }
    }
  };

</script>
